<template lang="pug">
  div
    .container
      h1 {{id}}
      h2 {{subId}}
      router-link(to="/") Top
</template>

<script>
export default {
  // データオブジェクト
  data() {
    return {
      id: this.$route.params.id || '',
      subId: this.$route.params.subid || ''
    }
  },
  // 算出プロパティ
  computed: {
  },
  // メソッド
  methods: {
  },
  // コンポーネント
  components: {
  },
  // インスタンス作成後
  created() {
    console.log('created')
  },
  // マウント後
  mounted() {
    console.log('mounted')
    this.$nextTick(() => {
      // ビュー全体がレンダリングされた後にのみ実行されるコード
      console.log('nextTick')
    })
  },
  // データ変更後
  updated() {
    console.log('updated')
  },
  // インスタンス破棄前
  beforeDestroy() {
    console.log('beforeDestroy')
  }
}
</script>